import { Skeleton } from '@mui/material'
import React from 'react'

const BANNER_SKELETON_HEIGHT = 60
const BANNER_SKELETON_HEIGHT_TABLET = 140
const BANNER_SKELETON_HEIGHT_MOBILE = 160

/**
 * Placeholder shown in place of a banner while the banner conditions are still loading.
 * Its height approximates a single banner so that reserving the space does not cause layout shift
 * once the real banner is rendered.
 */
const BannerSkeleton: React.FC = () => (
  <Skeleton
    variant="rectangular"
    sx={{
      borderRadius: 1,
      width: '100%',
      height: {
        xs: BANNER_SKELETON_HEIGHT_MOBILE,
        sm: BANNER_SKELETON_HEIGHT_TABLET,
        md: BANNER_SKELETON_HEIGHT,
      },
    }}
  />
)

export default BannerSkeleton
